import { Box, Typography } from '@mui/material'
import { IconSparkles } from '@tabler/icons-react'

import { assistantToolUiMetadata } from 'src/components/Assistant/tools'
import Row from 'src/components/Row/Row'

const containerSx = {
  px: '12px',
  gap: 2,
  '& .thread-message-tool-icon': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px !important',
    height: '48px !important',
    backgroundColor: (theme) => theme.palette.divider,
    borderRadius: '8px',
    flexShrink: 0,
  },

  '& .thread-message-tool-content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },

  '& .thread-message-tool-label': {
    fontWeight: 600,
  },

  '& .thread-message-tool-description': {
    fontSize: '12px',
    color: 'text.secondary',
  },
}

const ThreadToolCall = ({ toolCall }) => {
  const metadata = assistantToolUiMetadata[toolCall.name]
  return (
    <Row sx={containerSx}>
      <Box className="thread-message-tool-icon">
        {React.createElement(metadata.icon, { size: 26 })}
      </Box>
      <Box className="thread-message-tool-content">
        <Row gap={0.5}>
          <IconSparkles size={12} />
          <Typography className="thread-message-tool-label">
            {metadata.label}
          </Typography>
        </Row>
        <Typography className="thread-message-tool-description">
          {metadata.getDescription(toolCall.input)}
        </Typography>
      </Box>
    </Row>
  )
}

export default ThreadToolCall
